/**
 * Submits a hidden form POST and lets the browser handle the response
 * natively (e.g. file downloads). Used instead of `window.open` GET when the
 * payload cannot ride a URL (length limits) and instead of fetch-based
 * downloads to avoid buffering large files in memory as blobs.
 */
export const submitHiddenFormPost = ({
  url,
  fields,
  target,
}: {
  url: string;
  fields: Record<string, string>;
  target?: string;
}) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  if (target) {
    form.target = target;
  }
  form.style.display = 'none';

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
};
